import * as _ from "lodash";
import Organizations from "api/lib/data/Organizations";
import * as routes from "src/constants/routes";
import { Base, IBaseProps, IBaseState } from "../Common/Base";
import { IRoles } from "src/reducers/session";

export interface IOrganizationsBaseProps extends IBaseProps {
  orgId: string;
  roles?: IRoles;
  history: any;
}

export interface IOrganizationsBaseState extends IBaseState {
  orgs: any[];
  currentOrg: any;
  loading: boolean;
}

export default class OrganizationsBase<
  TProps extends IOrganizationsBaseProps,
  TState extends IOrganizationsBaseState
> extends Base<TProps, TState> {
  protected static INITIAL_STATE = {
    orgs: [],
    currentOrg: null,
    listeners: [],
    loading: true,
  };
  constructor(props: any) {
    super(props);
  }

  public componentDidMount = () => {
    this.getData();
  };

  public getData = () => {
    const { authUser, orgId } = this.props;
    const org = new Organizations();
    this.setState({ loading: true });
    this.getList(
      org,
      authUser.uid,
      (orgs: any[]) => {
        let currentOrg = null;
        if (orgId) {
          currentOrg = _.find(orgs, (o) => o.id === orgId);
        }

        this.setState({ orgs, currentOrg, loading: false });
      },
      (error: Error) => {
        this.setState({ loading: false });
      }
    );
  };
  protected handleOrgClicked = (selectedOrg: any) => {
    window.location.replace(routes.HOME(selectedOrg));
  };
}



// WEBPACK FOOTER //
// ./src/components/Organizations/OrganizationsBase.tsx